export default "__VITE_ASSET__KZKruE6i__"